import { DeclarationsTab } from "@features/production/components/DeclarationsTab";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { ClipboardCheck } from "lucide-react";

export const Route = createFileRoute("/_app/production/declarations/")({
  loader: requirePermission(PERMISSIONS.PRODUCTION.DECLARATIONS.VIEW),
  staticData: {
    title: "Déclarations",
    icon: ClipboardCheck,
    tab_icon: ClipboardCheck,
    permission: PERMISSIONS.PRODUCTION.DECLARATIONS.VIEW,
    section: "App",
    module: "production",
    order: 50,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
    description: "Déclarations de fabrication",
  },
  component: DeclarationsTab,
});
